import { styled } from '@mui/material/styles';
import {
  Drawer as MuiDrawer,
  Toolbar as MuiToolbar,
  Typography as MuiTypography,
  IconButton as MuiIconButton,
} from '@mui/material';
import { SidebarList } from './SidebarList';
import { NewButton } from './NewButton';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { getAccountDetails } from 'utils/account-details';

const drawerWidth = 255;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ theme, wide }) => ({
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.primary.darker,
    position: 'relative',
    whiteSpace: 'nowrap',
    width: wide ? drawerWidth : theme.spacing(7),
    height: '100vh',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    border: 'none',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      width: wide ? drawerWidth : theme.spacing(9),
    },
  },
}));

const Toolbar = styled(MuiToolbar)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  padding: '0 8px',
  mb: 1,
  '&.MuiToolbar-root': {
    padding: '0 14px',
  },
}));

const Typography = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ theme, wide }) => ({
  flexGrow: 1,
  fontSize: '16px',
  fontWeight: 600,
  letterSpacing: 1.2,
  display: wide ? 'block' : 'none',
  paddingLeft: '8px',
  color: theme.palette.common.white,
  overflow: 'hidden',
}));

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  color: theme.palette.primary.light,
  backgroundColor: 'inherit',
  borderRadius: '6px',
  padding: '8px 10px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const Sidebar = ({ wide, toggleWide }) => {
  const accountDetails = getAccountDetails();

  return (
    <Drawer
      variant="permanent"
      wide={wide}
      data-testid="sidebar"
    >
      <Toolbar>
        <IconButton onClick={toggleWide}>
          <MenuOutlinedIcon />
        </IconButton>
        <Typography
          component="h1"
          color="inherit"
          noWrap
          wide={wide}
        >
          Agents Space
        </Typography>
      </Toolbar>
      {accountDetails?.accountStatus === 'Active' && <NewButton wide={wide} />}
      <SidebarList
        wide={wide}
        toggleWide={toggleWide}
      />
    </Drawer>
  );
};
